import React from "react";
import {storesContext} from "../../../../common/stores/stores";
import TextInput from "../../../../common/components/shared/textInput/textInput";
import i18n from "../../../../i18n/i18n";
import DateAndTime from "../dateAndTime/dateAndTime";
import {ITimetableStore} from "../../../stores/timetableStore";
import DropDown from "../../../../common/components/shared/dropDown/dropDown";
import {DropDownModel} from "../../../../common/models/dropDown";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../../common/models/httpError";
import {Api} from "../../../../helpers/api";

interface StopActionSectionProps {
    actionIndex: number;
    wharfs: DropDownModel[];
    whrafsResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    reloadFunc: () => void;
}

export default class StopActionSection extends React.Component <StopActionSectionProps> {
    static contextType = storesContext;

    render() {
        const timetableStore = this.context.timetableStore as ITimetableStore;

        return (
            <>
                <div className="section with-border">
                    <DropDown
                        label={i18n.t("timetable.headers.wharf")}
                        validatedValue={timetableStore.actions[this.props.actionIndex].wharfId}
                        items={this.props.wharfs}
                        testId={`wharf-${this.props.actionIndex}`}
                        withoutSort
                        error={!Api.isSuccess(this.props.whrafsResponse) ? i18n.t("errorMessages.whrafsErrorSuffix") : ""}
                        reloadFunc={() => this.props.reloadFunc()}
                    />
                    <TextInput
                        label={i18n.t("timetable.headers.notes")}
                        validatedValue={timetableStore.actions[this.props.actionIndex].notes}
                        testId={`notes-${this.props.actionIndex}`}
                        className="notes"
                        maxLength={150}
                    />
                </div>
                <div className="section">
                    <div className="time-section">
                        <div>
                            <div className="time-header">{i18n.t("timetable.headers.plannedTime")}</div>
                            <DateAndTime
                                testId={`arrival-time-${this.props.actionIndex}`}
                                dateLabel={i18n.t("timetable.headers.arrivalTime")}
                                dateValue={timetableStore.actions[this.props.actionIndex].arrivalDate}
                                onChangeDate={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setArrivalDate(newDate);
                                }}
                                hourValue={timetableStore.actions[this.props.actionIndex].arrivalHour}
                                onChangeHour={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setArrivalHour(newDate);
                                }}
                                disabled={timetableStore.actions[this.props.actionIndex].hasOrderRegistered}
                            />
                            <DateAndTime
                                testId={`departure-time-${this.props.actionIndex}`}
                                dateLabel={i18n.t("timetable.headers.departureTime")}
                                dateValue={timetableStore.actions[this.props.actionIndex].departureDate}
                                onChangeDate={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setDepartureDate(newDate);
                                }}
                                hourValue={timetableStore.actions[this.props.actionIndex].departureHour}
                                onChangeHour={(newDate: Date | null) => {
                                    timetableStore.actions[this.props.actionIndex].setDepartureHour(newDate);
                                }}
                                disabled={timetableStore.actions[this.props.actionIndex].hasOrderRegistered}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
